'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const GRNThroughputChart = dynamic(
  () => import('@/app/analytics-dashboard/components/GRNThroughputChart'),
  { ssr: false, loading: () => <ChartSkeleton /> }
);

const InventoryStatusChart = dynamic(
  () => import('@/app/analytics-dashboard/components/InventoryStatusChart'),
  { ssr: false, loading: () => <ChartSkeleton /> }
);

const KittingAccuracyChart = dynamic(
  () => import('@/app/analytics-dashboard/components/KittingAccuracyChart'),
  { ssr: false, loading: () => <ChartSkeleton /> }
);

function ChartSkeleton() {
  return (
    <div className="card-elevated p-5 h-72">
      <div className="skeleton-pulse h-4 w-32 mb-4 rounded" />
      <div className="skeleton-pulse h-48 w-full rounded" />
    </div>
  );
}

export default function AnalyticsChartsRow() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
      {/* GRN Throughput — wider */}
      <div className="lg:col-span-3">
        <GRNThroughputChart />
      </div>
      {/* Inventory Status Donut */}
      <div className="lg:col-span-2">
        <InventoryStatusChart />
      </div>
      {/* Kitting Accuracy — full width */}
      <div className="lg:col-span-5">
        <KittingAccuracyChart />
      </div>
    </div>
  );
}